import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import socket from "./services/socket";

interface Order {
  orderNumber: string;
  status: string;
  [key: string]: any;
}

interface Notification {
  text: string;
  [key: string]: any;
}

const OrderNotifier = () => {
  // ⚡ Créer un objet audio pour le son de notification
  const notificationSound = new Audio(
    "../src/assets/sounds/vibration_notif.mp3"
  );

  // ⚡ Écoute des notifications envoyées depuis le backend
  useEffect(() => {
    const handleNotif = (notif: Notification) => {
      if (notif?.text) {
        toast.info(notif.text);

        // ⚡ Jouer le son
        notificationSound
          .play()
          .catch((err) => console.warn("Impossible de jouer le son:", err));
      }
    };

    const handleServerCall = (data: { tableNumber: string; callId: string; restaurantId: string }) => {
      const toastId = toast.info(
        `Table ${data.tableNumber} is calling for server`,
        {
          autoClose: false,
          closeOnClick: false,
          draggable: true,
        }
      );

      // Play sound repeatedly until dismissed
      const playSound = () => {
        notificationSound
          .play()
          .catch((err) => console.warn("Impossible de jouer le son:", err));
      };

      playSound();
      const soundInterval = setInterval(playSound, 2000);

      // Create a custom button to respond
      setTimeout(() => {
        const toastElement = document.querySelector(`[data-id="${toastId}"]`);
        if (toastElement) {
          const button = document.createElement("button");
          button.textContent = "OK";
          button.style.cssText = `
            margin-left: 10px;
            padding: 5px 15px;
            background: #007bff;
            color: white;
            border: none;
            borderRadius: 4px;
            cursor: pointer;
          `;
          button.onclick = () => {
            socket.emit("server-response", {
              callId: data.callId,
              tableNumber: data.tableNumber,
              restaurantId: data.restaurantId,
              response: "on-the-way",
            });
            clearInterval(soundInterval);
            toast.dismiss(toastId);
          };
          toastElement.appendChild(button);
        }
      }, 100);
    };

    const handleTableReservation = (notif: Notification) => {
      if (notif?.text) {
        toast.info(notif.text);
        notificationSound
          .play()
          .catch((err) => console.warn("Impossible de jouer le son:", err));
      }
    };

    const handleEventReservation = (notif: Notification) => {
      if (notif?.text) {
        toast.info(notif.text);
        notificationSound
          .play()
          .catch((err) => console.warn("Impossible de jouer le son:", err));
      }
    };

    const handleClientReclamation = (notif: Notification) => {
      if (notif?.text) {
        toast.info(notif.text);
        notificationSound
          .play()
          .catch((err) => console.warn("Impossible de jouer le son:", err));
      }
    };

    socket.on("new-order", handleNotif);
    socket.on("new-table-reservation", handleTableReservation);
    socket.on("new-event-reservation", handleEventReservation);
    socket.on("new-client-reclamation", handleClientReclamation);
    socket.on("server-call", handleServerCall);

    return () => {
      socket.off("new-order", handleNotif);
      socket.off("new-table-reservation", handleTableReservation);
      socket.off("new-event-reservation", handleEventReservation);
      socket.off("new-client-reclamation", handleClientReclamation);
      socket.off("server-call", handleServerCall);
    };
  }, []);

  return null;
};

export default OrderNotifier;
